import * as React from "react";
import IBSTableProps from "./IBSTable";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "../../../assets/sass/components/bsTable.scss";
import { imagePathurl } from "../../utils/utils";

/**
 * @name BSTable
 * @param props
 * @description Wrapper component for BootstrapTable from react-bootstrap-table-next to show
 * the draft list in table view
 * @category Widgets
 */

let sortField = "";
let sortBy = "";

interface IBSTablePropsState {
    currentPage?: any;
    // sortField?: any;
    // sortBy?: any;
}
class BSTable extends React.Component<IBSTableProps, IBSTablePropsState> {
    constructor(props) {
        super(props);
        this.state = {
            currentPage: 1,
            // sortField: "ContractorId",
            // sortBy: "asc",
        };
    }
    componentDidUpdate(prevProps) {
        const { paginationDetails } = this.props;
        // Setting the CurrentPage when total records don't match - this will display on Pagination - current page
        if (paginationDetails &&
            typeof paginationDetails.totalRecords !== 'undefined' &&
            prevProps.paginationDetails?.totalRecords !== paginationDetails.totalRecords) {
            this.setState({
                currentPage: paginationDetails.pageNo
            })
        }
    }

    handleNextPage = () => {
        const { currentPage } = this.state;
        const { paginationDetails, onTableDataChange } = this.props;
        if (currentPage !== paginationDetails.totalPages) {
            this.setState({ currentPage: currentPage + 1 }, () => {
                onTableDataChange(currentPage + 1, sortField, sortBy);
            });
        }
    };
    handlePrevPage = () => {
        const { currentPage } = this.state;
        const { onTableDataChange } = this.props;
        if (currentPage !== 1) {
            this.setState({ currentPage: currentPage - 1 }, () => {
                onTableDataChange(currentPage - 1, sortField, sortBy);
            });
        }
    };

    render() {
        const {
            hover,
            sortable,
            striped,
            condensed,
            bordered,
            tableColumnData,
            tableRowData,
            tableRowClick,
            defaultSorted,
            pagination,
            paginationDetails,
        } = this.props;
        
        //image CDN_PATH
        const getimagePath = imagePathurl();
        const totalPages = pagination ? paginationDetails.totalPages : 0;
        const rowEvents = {
            onClick: (e, row, rowIndex) => {
                window["AppInsightTrace"].trackEvent(`On table row click`);
                tableRowClick(row);
            },
        };
        const paginationColumnHeader = tableColumnData.map((column) => {
            if (column.sort && this.props.onTableDataChange) {
                column["onSort"] = (field, order) => {
                    const { currentPage } = this.state;
                    sortField = field;
                    sortBy = order;
                    this.props.onTableDataChange(currentPage, field, order);
                };
            }
            return column;
        });
        const sortOption = {
            sortCaret: (order, column) => {
                if (order === "asc") {
                    return (
                        <img
                            id={`${column.dataField}-sort-icon`}
                            className="ml6 asc"
                            src={`${getimagePath}arrow-drop-desc.svg`}
                        />
                    );
                } else if (order === "desc") {
                    return (
                        <img
                            id={`${column.dataField}-sort-icon`}
                            className="ml6 desc"
                            src={`${getimagePath}arrow-drop-desc.svg`}
                        />
                    );
                } else {
                    return (
                        <img
                            id={`${column.dataField}-sort-icon`}
                            className="ml6 asc-desc"
                            src={`${getimagePath}arrow_drop_down.svg`}
                        />
                    );
                }
            },
        };
        const paginationSortOption = {
            ...sortOption,
            sortFunc: (a, b, order, dataField, rowA, rowB) => {
                return;
            },
        };
        const rowClasses = (row, rowIndex) => {
            return `table-row-id-${row.id}`;
        };
        return (
            <>
                {pagination && tableRowData.length > 0 ? (
                    <div className="table-container">
                        <BootstrapTable
                            keyField="id"
                            bootstrap4
                            hover={hover}
                            condensed={condensed}
                            sorting={sortable}
                            sort={paginationSortOption}
                            striped={striped}
                            bordered={bordered}
                            defaultSorted={defaultSorted}
                            rowEvents={rowEvents}
                            data={tableRowData}
                            columns={paginationColumnHeader}
                            remote={{ sort: false }}
                        />
                        <div>
                            <div className="pagination-container">
                                <div
                                    id={"PrevBtn"}
                                    className={`page-nav ${this.state.currentPage === 1 ? "page-nav-disabled" : ""}`}
                                    onClick={() => this.handlePrevPage()}
                                >
                                    <img src={`${getimagePath}chevron-left-1.svg`} />
                                </div>
                                <span className="page-counter">{`${this.state.currentPage} OF ${totalPages}`}</span>
                                <div
                                    id={"NextBtn"}
                                    className={`page-nav ${
                                        this.state.currentPage === totalPages ? "page-nav-disabled" : ""
                                    }`}
                                    onClick={() => this.handleNextPage()}
                                >
                                    <img src={`${getimagePath}chevron-right-1.svg`} />
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <BootstrapTable
                        keyField="id"
                        bootstrap4
                        hover={hover}
                        condensed={condensed}
                        sorting={sortable}
                        sort={sortOption}
                        striped={striped}
                        bordered={bordered}
                        defaultSorted={defaultSorted}
                        rowEvents={rowEvents}
                        data={tableRowData}
                        columns={tableColumnData}
                        rowClasses={rowClasses}
                    />
                )}
            </>
        );
    }
}

export default BSTable;
